var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title || "Nº reserva", _vm.locale))+" ")]),_c('span',[_vm._v(_vm._s(_vm.booking.localizator))])])}
var staticRenderFns = []

export { render, staticRenderFns }